/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Button, Row, Col, DatePicker, TimePicker, Tooltip } from 'antd'
// import Button from '../button'
import moment from 'moment-timezone'
import './customRange.less'
import { AppError } from '../appError'
import { daysDifference } from '../../../../../utility/insightUtils'
import { DefaultTime, PickerFormat, jsonData } from '../../../../constants/constants'
import { Messages } from '../../../../constants/messages'
import { AppRoutes } from '../../../../constants/enums'
import { getFormattedDate } from '../../../../../utility/appUtil'
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage'

interface CustomRangeProps {
  displayHeading: string
  onChange: Function
  customValues?: any
  setCustomValues? : any
  start?: string
  from?: string
  end?: string
  to?: string
  className?: string
  setShowRefreshButton?: Function
  firstTimeFrame?: string  
}

const CustomRange = (props: CustomRangeProps) => {
  const { displayHeading, customValues, setCustomValues, start, end, from, to } = props
  const [customFromDate, setCustomFromDate] = useState(null)
  const [customToDate, setCustomToDate] = useState(null)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [customFromTime, setCustomFromTime] = useState(null)
  const [customEndTime, setCustomEndTime] = useState(null)
  const [editTimeFrame, setEditTimeFrame] = useState(false)
  const [errorMsg, setErrorMsg] = useState(null)
  const customDateFormat = 'D MMMM, YYYY' + " " + PickerFormat.TIME
  const dateFormat = 'D MMMM, YYYY'
  const localeInfo:any = secureLocalStorage.getItem('locale')
  moment.tz.setDefault(localeInfo.timezone)
  const { t } = useTranslation()

  useEffect(() => {
    props?.setShowRefreshButton?.(editTimeFrame)
  },[editTimeFrame])

  //custom date cal.
  const handleChangeStartDate = (evt: any, startdate: any) => {
    setEditTimeFrame(false)
    if(startdate && startdate.length){
      // Create moment object for validation
      const selectedStartMoment = moment.utc(startdate, localeInfo.momentFormat);
      let validDate = true;
      
      // Validate the selected date against timeframe requirements
      if (props.firstTimeFrame) {
        switch (props.firstTimeFrame) {
          case 'this week':
          case 'last week':
            // For weeks, first day must be Monday
            if (selectedStartMoment.day() !== 1) {
              setErrorMsg(t(Messages.PLEASE_SELECT_A_MONDAY));
              validDate = false;
            }
            break;
          case 'this month':
          case 'last month':
            // For months, must be the 1st of month
            if (selectedStartMoment.date() !== 1) {
              setErrorMsg(t(Messages.PLEASE_SELECT_THE_1ST_OF_THE_MONTH));
              validDate = false;
            }
            break;
          case 'this year':
          case 'last year':
            // For years, must be January 1st
            if (selectedStartMoment.date() !== 1 || selectedStartMoment.month() !== 0) {
              setErrorMsg(t(Messages.PLEASE_SELECT_JANUARY_1ST));
              validDate = false;
            }
            break;
          default:
            // Today and yesterday allow any date
            validDate = true;
        }
      }

      if (!validDate) {
        return; // Don't update state if date is invalid
      }
      
      // Clear any error if the date is valid
      setErrorMsg(null);

      // Set selected date
      setCustomFromDate(moment.utc(startdate, localeInfo.momentFormat).format(dateFormat));
      setCustomFromTime(moment.utc(startdate, localeInfo.momentDateTimeFormat).format(PickerFormat.TIME)) 
      setFromDate(moment.utc(startdate, localeInfo.momentFormat + "  " + PickerFormat.TIME).format(customDateFormat))

      // Auto-fill end date based on timeframe
      if(props.firstTimeFrame) {
        moment.updateLocale('en', {
          week: {
            dow: 1  // Set Monday as the first day of the week
          }
        });
        let endDate;
        const startMoment = moment.utc(startdate, localeInfo.momentFormat);

        switch (props.firstTimeFrame) {
          case 'today':
          case 'yesterday':
            // For day comparison, end date is same as start date
            endDate = startMoment.clone().endOf('day');
            break;
          case 'this week':
          case 'last week':
            // For week comparison, end date is end of the week (Sunday)
            endDate = startMoment.clone().endOf('week').endOf('day');
            break;
          case 'this month':
          case 'last month':
            // For month comparison, end date is end of the month
            endDate = startMoment.clone().endOf('month').endOf('day');
            break;
          case 'this year':
          case 'last year':
            // For year comparison, end date is end of the year
            endDate = startMoment.clone().endOf('year').endOf('day');
            break;
        }

        // Set the end date and time
        setCustomToDate(endDate.format(dateFormat));
        setCustomEndTime('23:59');
        setToDate(endDate.format(customDateFormat));
      }
    }
    else{
      setCustomFromDate(null)
      setCustomFromTime(null)
      setFromDate(null)
    }
  }

  const handleChangeEndDate = (evt: any, enddate: any) => {
    setEditTimeFrame(false)
    if(enddate && enddate.length){
      setToDate(moment.utc(enddate, localeInfo.momentFormat + "  " + PickerFormat.TIME).format(customDateFormat));
      setCustomEndTime(moment.utc(enddate, localeInfo.momentDateTimeFormat).format(PickerFormat.TIME)) 
      setCustomToDate(moment.utc(enddate, localeInfo.momentFormat).format(dateFormat));
    }
    else{
      setCustomToDate(null)
      setCustomEndTime(null)
      setToDate(null)
    }
  }

  // const handlestarttimepicker = (evt: any, starttime: any) => {
  //   setEditTimeFrame(false)
  //   starttime?.length ? setCustomFromTime(starttime) : setCustomFromTime(null)
  // }
  // const handleendtimepicker = (evt: any, endtime: any) => {
  //   setEditTimeFrame(false)
  //   endtime?.length ? setCustomEndTime(endtime) : setCustomEndTime(null)
  // }

  const checkInterval = (startDate: string, endDate: string) => {
    let numberOfDays = daysDifference(startDate, endDate)

    console.log("numberOfDays", numberOfDays);

    switch (true) {
      case numberOfDays < 0:
        setErrorMsg(t(Messages.INVALID_RANGE))
        return false
      case isNaN(numberOfDays):
        customFromDate
          ? setErrorMsg(t(Messages.SELECT_END_DATE))
          : setErrorMsg(t(Messages.SELECT_START_DATE))
        return false
      default:
        if(numberOfDays > 366 && window.location.pathname === AppRoutes.INSIGHTS){
          setErrorMsg(t(Messages.DATA_NOT_SUPPORTED))
          return false
        }
        setErrorMsg(null)
        return true
    }
  }

  // Separate functions for placeholder and error message
  const getDatePickerPlaceholder = (timeFrame: string) => {
    switch (timeFrame) {
      case 'today':
      case 'yesterday':
        return t(Messages.PLEASE_SELECT_A_DAY);
      case 'this week':
      case 'last week':
        return t(Messages.PLEASE_SELECT_A_MONDAY);
      case 'this month':
      case 'last month':
        return t(Messages.PLEASE_SELECT_THE_1ST_OF_THE_MONTH);
      case 'this year':
      case 'last year':
        return t(Messages.PLEASE_SELECT_JANUARY_1ST);
      default:
        return t(jsonData['SelectDate&Time']);
    }
  };

  const getDatePickerErrorMessage = (timeFrame: string, selectedDate: any) => {
    if (!selectedDate) {
      // Return error for empty selection
      switch (timeFrame) {
        case 'today':
        case 'yesterday':
          return t(Messages.PLEASE_SELECT_A_DAY);
        case 'this week':
        case 'last week':
          return t(Messages.PLEASE_SELECT_A_MONDAY);
        case 'this month':
        case 'last month':
          return t(Messages.PLEASE_SELECT_THE_1ST_OF_THE_MONTH);
        case 'this year':
        case 'last year':
          return t(Messages.PLEASE_SELECT_JANUARY_1ST);
        default:
          return '';
      }
    }
    
    // Check if selected date matches expected format
    const selectedMoment = moment.utc(selectedDate, dateFormat);
    
    switch (timeFrame) {
      case 'today':
      case 'yesterday':
        // No additional validation for days
        return '';
      case 'this week':
      case 'last week':
        // Check if selected date is Monday
        return selectedMoment.day() === 1 ? '' : t(Messages.PLEASE_SELECT_A_MONDAY);
      case 'this month':
      case 'last month':
        // Check if selected date is 1st of month
        return selectedMoment.date() === 1 ? '' : t(Messages.PLEASE_SELECT_THE_1ST_OF_THE_MONTH);
      case 'this year':
      case 'last year':
        // Check if selected date is January 1st
        return (selectedMoment.date() === 1 && selectedMoment.month() === 0) ? '' : t(Messages.PLEASE_SELECT_JANUARY_1ST);
      default:
        return '';
    }
  };

  //on click timeframe button
  const handletimeframe = () => {
    let startTime = customFromTime ?? DefaultTime.START
    let endTime = customEndTime ?? DefaultTime.END
    let start = customFromDate + ' ' + startTime
    let end = customToDate + ' ' + endTime
    if (checkInterval(start, end)) {
      !customFromTime && setCustomFromTime(DefaultTime.START)
      !customEndTime && setCustomEndTime(DefaultTime.END)
      props.onChange({
        customEndDate: getFormattedDate(customToDate ,'YYYY-MM-DD'),
        customStartDate: getFormattedDate(customFromDate ,'YYYY-MM-DD'),
        customStartTime: startTime,
        customEndTime: endTime,
      })
      setEditTimeFrame(!editTimeFrame)
    }
  }

  // Customize the DatePicker to enforce the specific date selection
  const disabledDate = (current) => {
    if (!props.firstTimeFrame) return false;
    
    const date = current.date();
    const month = current.month();
    const day = current.day();

    switch (props.firstTimeFrame) {
      case 'this week':
      case 'last week':
        // Only allow Mondays (day 1)
        return day !== 1;
      case 'this month':
      case 'last month':
        // Only allow 1st of month
        return date !== 1;
      case 'this year':
      case 'last year':
        // Only allow January 1st
        return date !== 1 || month !== 0;
      default:
        // No constraints for today/yesterday
        return false;
    }
  };

  useEffect(() => {
    if (customValues) {
      const startDate = start + " " + from
      const endDate = end + " " + to
      setCustomFromDate(getFormattedDate(start ,dateFormat))
      setCustomToDate(getFormattedDate(end ,dateFormat))
      setCustomFromTime(from ?? DefaultTime.START)
      setCustomEndTime(to ?? DefaultTime.END)
      setFromDate(getFormattedDate(startDate , customDateFormat))
      setToDate(getFormattedDate(endDate,customDateFormat))
      setCustomValues(false)
      setEditTimeFrame(true)
    }
  }, [customValues, start])

  return (
    <div className={`customRangeDiv ${props?.className}`}>
      <hr className="customRange-hrBorder" />
      <Row className="customHeader">
        {/* <span className="customRange-Text">From</span> */}
        {/* <Col className="timePickerBox">
          <TimePicker
      
            placeholder={DefaultTime.START}
            onChange={handlestarttimepicker}
            format={PickerFormat.TIME}
            className="timePickerStyl customRange-timePicker"
            value={
              customFromTime ? moment.utc(customFromTime, PickerFormat.TIME) : null
            }
          />
        </Col> */}
        <span className="customRange-Text">{t(jsonData.From)}</span>
        <Col className="datepickerBox">
          <DatePicker
            placeholder={props.firstTimeFrame ? getDatePickerPlaceholder(props.firstTimeFrame) : t(jsonData['SelectDate&Time'])}
            showTime={{ format: 'HH:mm' , defaultValue:moment('00:00', 'HH:mm')}}
            format={localeInfo.momentFormat +" " + PickerFormat.TIME}
            onChange={handleChangeStartDate}
            disabledDate={disabledDate}
            suffixIcon={null}
            className={`datepicker customRange-timePicker ${errorMsg === t(Messages.SELECT_START_DATE) || (props.firstTimeFrame && getDatePickerErrorMessage(props.firstTimeFrame, customFromDate)) ? 'error' : ''}`}
            value={fromDate ? moment.utc(fromDate, customDateFormat) : null}
          />
        </Col>
        <span className="customRange-Text">{t(jsonData.to)}</span>
        {/* <Col className="timePickerBox">
          <TimePicker
            
            onChange={handleendtimepicker}
            placeholder={DefaultTime.END}
            format={PickerFormat.TIME}
            className="timePickerStyl customRange-timePicker"
            value={
              customEndTime ? moment.utc(customEndTime, PickerFormat.TIME) : null
            }
          />
        </Col> */}
        {/* <span className="customRange-Text">on</span> */}
        <Col className="datepickerBox">
          <DatePicker
            placeholder={t(jsonData['SelectEndDate&Time'])}
            showTime={{ format: 'HH:mm',defaultValue:moment('23:59', 'HH:mm')}}
            format={localeInfo.momentFormat + " " + PickerFormat.TIME}
            suffixIcon={null}
            onChange={handleChangeEndDate}
            className={`datepicker customRange-timePicker ${errorMsg === t(Messages.SELECT_END_DATE) ? 'error' : ''}`}
            value={toDate ? moment.utc(toDate, customDateFormat) : null}
            disabled={!!props.firstTimeFrame}
          />
        </Col>
        <Col
          
          className={editTimeFrame && 'edittimeframeCol editUpdatetimeFrame'}
        >
          {!editTimeFrame && 
            <Tooltip overlayClassName='dashBoardTooltip' placement="bottom" title={t(jsonData.UpdateRange)}>
              <Button
                type="primary"
                key="submit"
                htmlType="submit"
                onClick={handletimeframe}
                className="updateTimeFrameBtn"
              >
                {t(jsonData.UpdateRange)}
              </Button>
            </Tooltip>
          }
        </Col>
      </Row>
      <div className="pl-vw">
        <AppError 
          show={props.firstTimeFrame && Boolean(getDatePickerErrorMessage(props.firstTimeFrame, customFromDate))} 
          errorMsg={props.firstTimeFrame ? getDatePickerErrorMessage(props.firstTimeFrame, customFromDate) : ''} 
        />
        <AppError show={errorMsg !== null} errorMsg={errorMsg} />
      </div>
      <hr className="customRange-hrBorder" />
    </div>
  )
}

export default CustomRange
